import __request__ from "routing/request";
export function all(requestOptions) {
  return __request__("GET", "/system/indexer/indices", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function closed(requestOptions) {
  return __request__("GET", "/system/indexer/indices/closed", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function multiple(Requestedindices, requestOptions) {
  return __request__("POST", "/system/indexer/indices/multiple", Requestedindices, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function open(requestOptions) {
  return __request__("GET", "/system/indexer/indices/open", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getOutdatedIndices(requestOptions) {
  return __request__("GET", "/system/indexer/indices/outdated", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function reopened(requestOptions) {
  return __request__("GET", "/system/indexer/indices/reopened", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function indexSetClosed(indexSetId, requestOptions) {
  return __request__("GET", `/system/indexer/indices/${indexSetId}/closed`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function indexSetList(indexSetId, requestOptions) {
  return __request__("GET", `/system/indexer/indices/${indexSetId}/list`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function indexSetOpen(indexSetId, requestOptions) {
  return __request__("GET", `/system/indexer/indices/${indexSetId}/open`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function indexSetReopened(indexSetId, requestOptions) {
  return __request__("GET", `/system/indexer/indices/${indexSetId}/reopened`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function single(index, requestOptions) {
  return __request__("GET", `/system/indexer/indices/${index}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(index, requestOptions) {
  return __request__("DELETE", `/system/indexer/indices/${index}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function close(index, requestOptions) {
  return __request__("POST", `/system/indexer/indices/${index}/close`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function reopen(index, requestOptions) {
  return __request__("POST", `/system/indexer/indices/${index}/reopen`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
